import { useEffect, useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FoundersSection from './components/FoundersSection';
import TeamSection from './components/TeamSection';
import ServicesSection from './components/ServicesSection';
import PartnershipsSection from './components/PartnershipsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

export default function HomePage() {
  const [showWhatsAppTooltip, setShowWhatsAppTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWhatsAppTooltip(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <AboutSection />
      <FoundersSection />
      <TeamSection />
      <ServicesSection />
      <PartnershipsSection />
      <ContactSection />
      <Footer />
      <WhatsAppFloat showTooltip={showWhatsAppTooltip} onCloseTooltip={() => setShowWhatsAppTooltip(false)} />
    </div>
  );
}
